import { render } from "./Postcard.vue?vue&type=template&id=6a111afe"
import script from "./Postcard.vue?vue&type=script&lang=js"
export * from "./Postcard.vue?vue&type=script&lang=js"

import "./Postcard.vue?vue&type=style&index=0&id=6a111afe&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__